import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

const PurchaseSuccess: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        padding: 2
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          maxWidth: 500,
          textAlign: 'center',
          borderRadius: 2
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 3
          }}
        >
          <CheckCircle
            sx={{
              fontSize: 80,
              color: '#22B060'
            }}
          />
        </Box>
        
        <Typography
          variant="h4"
          sx={{
            marginBottom: 2,
            color: '#333',
            fontWeight: 600
          }}
        >
          Purchase Successful!
        </Typography>
        
        <Typography
          variant="body1"
          sx={{
            marginBottom: 3,
            color: '#666',
            fontSize: '16px',
            lineHeight: 1.6
          }}
        >
          Your purchase has been processed successfully. You can close this popup now.
        </Typography>
      </Paper>
    </Box>
  );
};

export default PurchaseSuccess;

